import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Space, Typography } from 'antd';
import { DependentData } from '../DependentsPage';
import { CheckCircleFilled } from '@ant-design/icons';

interface ManageDependentProps {
  dependentData: DependentData;
}

export const ManageDependent = ({ dependentData }: ManageDependentProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Space direction="vertical">
      <Space>
        <CheckCircleFilled style={{ color: '#92D048' }} />
        <Typography.Text type="secondary">{t('profile.registered')}</Typography.Text>
      </Space>
      <Button type="primary" onClick={() => navigate('/dependents/manage', { state: dependentData })}>
        {t('profile.manage')}
      </Button>
    </Space>
  );
};
